import React, { useState } from 'react';
import * as S from './TitleBar.styles';

const TitleBar = ({heading}) => {
if(!heading){
  return null;
}
  return (
    <S.TitleWrap>
      <h2>{heading}</h2>
    </S.TitleWrap>
  );
};

export default TitleBar;
